var contactServiceMixin = {
    data: function () {
        return {
            CONTACT_BASE: '/Api/Contact/'
        }
    },
    methods: {
        contactForm: function(data) {
            return this.post(this.CONTACT_BASE, 'ContactForm', data, true);
        },
        askAQuestion: function(data) {
            return this.post(this.CONTACT_BASE, 'AskAQuestion', data, true);
        },
        quoteMe: function (data) {
            return this.post(this.CONTACT_BASE, 'QuoteMe', data, true);
        }
    } 
}